/**
 * Copyright (c) 2019 CRF Box Oy. All Rights Reserved. Company Confidential.
 */

import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { fetchOrganizationsBySponsor } from '../../../actions/actions';
import PeopleDetailsGridComponent from './people.details.grid.component';
import {
  fetchRoles,
  fetchAssignments,
  clearRoleManagementErrors,
  updateCanConsentAndPhi,
  updatingCanConsentAndPhi,
  updatingCanConsentAndPhiFailed
} from '../../../actions/rolemanagement.actions';

export const mapStateToProps = (state, ownProps) => {
  return {
    userAssignments: state.rolemanagement.userAssignments,
    error: state.rolemanagement.error,
    errorUnassigned: state.study.errorUnassigned,
    selectedSponsor: state.sponsor.selectedSponsor,
    user: ownProps.user,
    isFetching:
      state.roles.isFetchingRoles ||
      state.study.isFetchingUnassigned ||
      state.rolemanagement.isFetching ||
      state.rolemanagement.assignmentSaving,
    roles: state.roles.roles,
    organizations: state.organizations.items,
    isUpdatingPhiConsent: state.rolemanagement.isUpdatingPhiConsent
  };
};

export const mapDispatchToProps = (dispatch) => {
  return {
    loadData: (userId, sponsor) => {
      dispatch(fetchRoles(sponsor, userId));
      dispatch(fetchAssignments(userId, sponsor));
      dispatch(fetchOrganizationsBySponsor(sponsor));
    },
    updatingCanConsentAndPhi: () => {
      dispatch(updatingCanConsentAndPhi());
    },
    updateCanConsentAndPhi: (updatedRowData) => {
      dispatch(updateCanConsentAndPhi(updatedRowData));
    },
    updatingCanConsentAndPhiFailed: (updatedRowData) => {
      dispatch(updatingCanConsentAndPhiFailed(updatedRowData));
    },
    clearErrors: () => {
      dispatch(clearRoleManagementErrors());
    }
  };
};

const PeopleDetailsGridContainer = withRouter(connect(mapStateToProps, mapDispatchToProps)(PeopleDetailsGridComponent));

export default PeopleDetailsGridContainer;
